import { render, staticRenderFns } from "./DentalWorkspace.vue?vue&type=template&id=cbec2c88&scoped=true"
import script from "./DentalWorkspace.vue?vue&type=script&lang=js"
export * from "./DentalWorkspace.vue?vue&type=script&lang=js"
import style0 from "./DentalWorkspace.vue?vue&type=style&index=0&id=cbec2c88&prod&scoped=true&lang=css"
import style1 from "./DentalWorkspace.vue?vue&type=style&index=1&id=cbec2c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbec2c88",
  null
  
)

export default component.exports